import * as React from "react";
import { forwardRef } from "react";
const SvgArrowFullDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 4, viewBox: "0 0 8 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector 312", d: "M3.49691e-07 -2.22545e-07L8 4.76837e-07L4 4L3.49691e-07 -2.22545e-07Z", fill: "#191919" }));
const ForwardRef = forwardRef(SvgArrowFullDown);
export default ForwardRef;
